<template>
    <div class="new-test">
        <el-card class="container creat-contant" shadow="never">
            <h4 class="new-test-title" v-text="titleText"></h4>
            <el-steps simple v-if="isAdd" :active="activeStep">
                <el-step v-for="step in steps" :key="step.title" :title="step.title" :icon="step.icon"></el-step>
            </el-steps>
            <!-- 失活的组件将会被缓存！-->
            <keep-alive>
                <component
                    :is="steps[activeStep].component"
                    @change-step="changeStep"
                    @submit="stepSubmit"
                    :isAdd="isAdd"
                    :raceExpUid="raceExpUid"
                    :testUid="testUid">
                </component>
            </keep-alive>
        </el-card>
    </div>
</template>
<script>
import testCreat from "./components/test-creat";
import testExaminee from "./components/test-examinee";
import testSet from "./components/test-set";
import { addEtexam } from '@/api/exam/etexam'
export default {
    data() {
        return {
            form: {},
            isAdd: true,
            testUid: "",
            raceExpUid: "",
            activeStep: null,
            steps: [
                {
                    title: "考试信息",
                    icon: "el-icon-edit-outline",
                    component: "testCreat"
                },
                {
                    title: "试卷设置",
                    icon: "el-icon-document",
                    component: "testSet"
                },
                {
                    title: "考生设置",
                    icon: "el-icon-document-checked",
                    component: "testExaminee"
                }
            ],
            urlText: ["creat", "set", "examinee"]
        };
    },
    components: {
        testCreat,
        testExaminee,
        testSet
    },
    computed: {
        titleText: function() {
            return `${this.isAdd ? "添加" : "编辑"}考试${
                this.activeStep === 1 ? "步骤" : ""
            }`;
        }
    },
    methods: {
        init() {
            let raceExpUid = this.$route.params.testUid;
            let step = this.$route.params.step;
            let activeStep = 0;
            if (step === "examinee") {
                activeStep = 1;
            }
            if (step === "set") {
                activeStep = 2;
            }
            this.isAdd = raceExpUid === "add";
            this.raceExpUid = raceExpUid;
            this.setActiveStep(activeStep);
        },
        setActiveStep(index) {
            let val = index;
            let arr = this.steps;
            if (index < 0) {
                val = 0;
            }
            if (index > arr.length - 1) {
                val = arr.length - 1;
            }
            this.activeStep = val;
            this.$router.push({
                name: "newTest",
                params: {
                    ...this.$route.params,
                    step: this.urlText[val]
                }
            });
        },
        changeStep(num) {
            this.setActiveStep(this.activeStep + num);
        },
        stepSubmit(form) {
            this.form = {
                ...this.form,
                ...form
            }
            if (this.activeStep === this.steps.length - 1) {
                // 新增考试
                addEtexam(this.form).then(() => {
                    this.$router.push({ name: 'userManagement' })
                })
            } else {
                this.setActiveStep(this.activeStep + 1);
            }
        }
    },
    created() {
        this.init();
    }
};
</script>

<style lang="less" scoped>
.new-test {
    min-height: 500px;
    background-color: #fff;
    .new-test-title {
        text-align: center;
        line-height: 3em;
        border-bottom: 1px solid #e6e6e6;
    }
}
</style>
